<template>
  <div class="loading" :style="{ display: ativo ? 'block' : 'none' }">
    <div class="loading-container">
      <div class="sk-fading-circle">
        <div class="sk-circle1 sk-circle"></div>
        <div class="sk-circle2 sk-circle"></div>
        <div class="sk-circle3 sk-circle"></div>
        <div class="sk-circle4 sk-circle"></div>
        <div class="sk-circle5 sk-circle"></div>
        <div class="sk-circle6 sk-circle"></div>
        <div class="sk-circle7 sk-circle"></div>
        <div class="sk-circle8 sk-circle"></div>
        <div class="sk-circle9 sk-circle"></div>
        <div class="sk-circle10 sk-circle"></div>
        <div class="sk-circle11 sk-circle"></div>
        <div class="sk-circle12 sk-circle"></div>
      </div>
      <span class="loading-message">{{ mensagem || 'Só um momento que estamos carregando as informações...' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ativo', 'mensagem'],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Loading.vue?648dc1fc